export default function Pagination({ page, pageSize, total, onPage }) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize))
  const start = total === 0 ? 0 : (page - 1) * pageSize + 1
  const end = Math.min(page * pageSize, total)

  return (
    <div style={styles.wrap}>
      <span style={styles.info}>
        {total === 0 ? 'No results' : `${start}–${end} of ${total} prospects`}
      </span>
      <div style={styles.controls}>
        <button
          style={styles.btn}
          onClick={() => onPage(page - 1)}
          disabled={page <= 1}
        >
          ← Prev
        </button>
        <span style={styles.pages}>
          Page {page} of {totalPages}
        </span>
        <button
          style={styles.btn}
          onClick={() => onPage(page + 1)}
          disabled={page >= totalPages}
        >
          Next →
        </button>
      </div>
    </div>
  )
}

const styles = {
  wrap: {
    display: 'flex', alignItems: 'center',
    justifyContent: 'space-between', marginTop: 12,
  },
  info: { fontSize: 12, color: '#888' },
  controls: { display: 'flex', alignItems: 'center', gap: 8 },
  pages: { fontSize: 12, color: '#888' },
  btn: {
    border: '0.5px solid #ccc', background: 'none',
    borderRadius: 8, padding: '4px 12px', fontSize: 12,
    cursor: 'pointer', color: '#1a1a1a',
  },
}
